<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import Profile from "./profile";
// import MonthlyBookings from "./monthly-bookings";

// import WeeklyPending from "./weekly-pending";
// import WeeklyConfirmed from "./weekly-confirmed";
// import WeeklyCompleted from "./weekly-completed";
// import WeeklyCancelled from "./weekly-cancelled";

import Stat from "./stat";
import simplebar from "simplebar-vue";

/**
 * Dashboard Component
 */
export default {
   page: {
      title: "Dashboard",
      meta: [
         {
           name: "description",
           content: appConfig.description,
         },
      ],
   },
   components: {
      Layout,
      PageHeader,
      Profile,
      Stat,
      // MonthlyBookings, 
      // WeeklyPending, 
      // WeeklyConfirmed,
      // WeeklyCompleted,
      // WeeklyCancelled,  
      simplebar
   },
   data() {
      return {
         title: "Dashboard",
         items: [
            {
               text: "Dashboard",
               active: true,
            },        
         ],

         statData: [
            {
               icon: "bx bxs-calendar-event",
               title: "Pending",
               value: 0,
            },
            {
               icon: "bx bxs-calendar-event",
               title: "Completed",
               value: 0,
            },
            {
               icon: "bx bxs-calendar-event",
               title: "Cancelled",
               value: 0,
            },
            {
               icon: "fas fa-user-md",
               title: "Doctors",
               value: 0,
            },
            {
               icon: "bx bx-user",
               title: "Users",
               value: 0,
            },
            {
               icon: "fas fa-clinic-medical",
               title: "Clinics",
               value: 0,
            },
        
         ],    

         doctors: {
            active: 0,
            inactive: 0,
         },

         today_pending: [],
         today_confirmed: [],
         today_completed: [],
         today_cancelled: [],

         month: [],

         pending_week: [],
         confirmed_week: [],
         completed_week: [],
         cancelled_week: [],
         
         isLoading: false,
         fullPage: true,
         canCancel: false,
         useSlot: false,
         loader: "spinner",
         color: "#007bff",
         bgColor: "#ffffff",
         height: 128,
         width: 128,
         timeout: 3000, //ms
         fetchingStats: true,
         earningStatus: true,

      };
   },
   mounted() {
    
   },

   created() {
      this.fetchDashboard();
   },

   methods: {
      fetchDashboard() {
         let url = "admin/dashboard";
            
         this.getToken();
         this.loading = true;
         this.$axios
         .get(url, { headers: { Authorization: "Bearer " + this.token } })
         .then((res) => {
            var data = res.data.data;
            console.log(data);                 

            this.statData[0].value = data.pending;
            this.statData[1].value = data.completed;
            this.statData[2].value = data.cancelled;   
            this.statData[3].value = data.doctors;   
            this.statData[4].value = data.users;   
            this.statData[5].value = data.clinics;   

            this.doctors.active = data.active_doctors;
            this.doctors.inactive = data.blocked_doctors;

            this.today_pending = data.today_pending;
            this.today_confirmed = data.today_confirmed;
            this.today_completed = data.today_completed;
            this.today_cancelled = data.today_cancelled;  

            this.month[0] = { name: "Pending", data: data.pending_month };
            this.month[1] = { name: "Confirmed", data: data.confirmed_month };
            this.month[2] = { name: "Completed", data: data.completed_month };
            this.month[3] = { name: "Cancelled", data: data.cancelled_month };              

            this.pending_week[0] = data.pending_week;     
            this.confirmed_week[0] = data.confirmed_week;
            this.completed_week[0] = data.completed_week;
            this.cancelled_week[0] = data.cancelled_week;
               
         })
         .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
         })
         .finally(() => (this.loading = false));
      },
      getToken() {
            if (localStorage.getItem('sigomind_admin')) {
               var sigomind_admin =  JSON.parse(localStorage.getItem('sigomind_admin'));
               if(sigomind_admin.token) {
                  this.token = sigomind_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
      }, 
   }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-4">
        <Profile :updating="loading" :doctors="doctors" />

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Todays Bookings</h4>
            <b-tabs pills justified nav-class="bg-light rounded" content-class="mt-4">
              <b-tab title="Pending" active>
                <b-card-text>
                  <simplebar style="max-height: 330px">
                    <table
                      class="table table-centered align-middle"
                    >

                      <tbody v-if="Boolean(today_pending.length)">
                        <tr v-for="data of today_pending" :key="data.id">
                          <td>                            
                            <h6>{{data.converted_enquiry_date}}</h6>
                          </td>
                          <td>
                            <div>
                              <h5 class="font-size-14 mb-1">{{ data.patient.name }}</h5>
                              <p>Dr. {{ data.doctor.doctor_name }}</p>
                            </div>
                          </td>                         
                        </tr>
                      </tbody>

                      <tbody v-else>
                         <tr> 
                           <td colspan="2">No pending bookings</td>
                         </tr>
                      </tbody>

                    </table>
                  </simplebar>
                </b-card-text>
              </b-tab>

              <b-tab title="Confirmed">
                <b-card-text>
                  <simplebar style="max-height: 330px">
                    <table
                      class="table table-centered align-middle"
                    >
                      <tbody v-if="Boolean(today_confirmed.length)">
                        <tr v-for="data of today_confirmed" :key="data.id">
                          <td>                            
                            <h6>{{data.booking_datetime | formatDate}}</h6>
                          </td>
                          <td>
                            <div>
                              <h5 class="font-size-14 mb-1">{{ data.patient.name }}</h5>
                              <p>Dr. {{ data.doctor.doctor_name }}</p>
                            </div>
                          </td>                         
                        </tr>
                      </tbody>
                      <tbody v-else>
                         <tr> 
                           <td colspan="2">No confirmed bookings</td>
                         </tr>
                      </tbody>

                    </table>
                  </simplebar>
                </b-card-text>
              </b-tab>

              <b-tab title="Completed">
                <b-card-text>
                  <simplebar style="max-height: 330px">
                    <table
                      class="table table-centered align-middle"
                    >
                      <tbody v-if="Boolean(today_completed.length)">
                        <tr v-for="data of today_completed" :key="data.id">
                          <td>                            
                            <h6>{{data.booking_datetime | formatDate}}</h6>
                          </td>
                          <td>
                            <div>
                              <h5 class="font-size-14 mb-1">{{ data.patient.name }}</h5>
                              <p>Dr. {{ data.doctor.doctor_name }}</p>
                            </div>
                          </td>                         
                        </tr>
                      </tbody>

                      <tbody v-else>
                         <tr> 
                           <td colspan="2">No completed bookings</td>
                         </tr>
                      </tbody>

                    </table>
                  </simplebar>
                </b-card-text>
              </b-tab>

              

              <b-tab title="Cancelled">
                <b-card-text>
                  <simplebar style="max-height: 330px">
                    <table
                      class="table table-centered align-middle"
                    >
                      <tbody v-if="Boolean(today_cancelled.length)">
                        <tr v-for="data of today_cancelled" :key="data.id">
                          <td>                            
                            <h6>{{data.booking_datetime | formatDate}}</h6>
                          </td>
                          <td>
                            <div>
                              <h5 class="font-size-14 mb-1">{{ data.patient.name }}</h5>
                              <p>Dr. {{ data.doctor.doctor_name }}</p>
                            </div>
                          </td>                         
                        </tr>
                      </tbody>

                      <tbody v-else>
                         <tr> 
                           <td colspan="2">No cancelled bookings</td>
                         </tr>
                      </tbody>

                    </table>
                  </simplebar>
                </b-card-text>
              </b-tab>
              
            </b-tabs>
          </div>
        </div>



      </div>
      <!-- end col -->
      <div class="col-xl-8">
        <div class="row">
          <div v-for="(stat, index) of statData" :key="index" class="col-md-4">
            <Stat :icon="stat.icon" :title="stat.title" :value="stat.value" />
          </div>
        </div>
        
        <MonthlyBookings :series = "month"/>


      </div>
    </div>
    <!-- end row -->

    <!-- <div class="row">
      <div class="col-lg-3">
        <WeeklyPending :updating="earningStatus" />
      </div>

      <div class="col-lg-3">
        <WeeklyConfirmed :updating="earningStatus" :series="confirmed_week"/>
      </div>

      <div class="col-lg-3">
        <WeeklyCompleted :updating="earningStatus"  />
      </div>

      <div class="col-lg-3">
        <WeeklyCancelled :updating="earningStatus" />
      </div>
    </div> -->


    
  </Layout>
</template>
